import { Group, Kbd, Modal, Text } from '@mantine/core';
import { useDisclosure, useHotkeys } from '@mantine/hooks';

import { IconSearch } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { SearchModalContent } from './SearchModalContent';

export function SearchBar() {
  const [opened, { open, close }] = useDisclosure(false);
  useHotkeys([
    [
      'mod+k',
      event => {
        event.preventDefault();
        open();
      },
    ],
  ]);

  return (
    <>
      <FakeInput onClick={open} />
      <Modal
        opened={opened}
        onClose={close}
        withCloseButton={false}
        radius="md"
        padding="04"
        size={875}
      >
        <SearchModalContent onClose={close} />
      </Modal>
    </>
  );
}

type FakeInputProps = {
  onClick: () => void;
};

function FakeInput({ onClick }: FakeInputProps) {
  const { t } = useTranslation('search');
  return (
    <Group
      noWrap
      spacing="04"
      h={34}
      onClick={onClick}
      px="02"
      bg="gray.0"
      sx={theme => ({
        cursor: 'pointer',
        borderRadius: theme.radius.md,
        '&:hover': {
          backgroundColor: theme.colors.gray[1],
        },
      })}
    >
      <Group noWrap spacing="02" c="gray.4">
        <IconSearch size={16} />
        <Text variant="sm" fw={400} truncate lineClamp={1}>
          {t('input.placeholder')}
        </Text>
      </Group>
      <ShortCutDisplay />
    </Group>
  );
}

function ShortCutDisplay() {
  const isMac = navigator.userAgent.includes('Mac');

  return (
    <Group noWrap spacing="01" c="gray.8">
      <Kbd size="xs">{isMac ? '⌘' : 'Ctrl'}</Kbd>
      <span>+</span>
      <Kbd size="xs">K</Kbd>
    </Group>
  );
}
